import { routes } from 'app/routing/routesConfig';
import { HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { ChakraLink } from 'app/components/Core/ChakraLink';

interface LogInLinkProps extends StackProps {}

export const LogInLink = (props: LogInLinkProps) => (
  <VStack borderTop="1px solid" borderColor="M.30" w="full" mx="auto">
    <HStack
      mx="auto"
      pt={8}
      fontWeight={400}
      fontSize="sm"
      letterSpacing="0.25px"
      {...props}
    >
      <Text lineHeight="17px">Have an account?</Text>
      <ChakraLink to={routes.auth.path} fontWeight={600} lineHeight="17px">
        Sign In
      </ChakraLink>
    </HStack>
  </VStack>
);
